import React from "react";
import { Link, Switch } from "react-router-dom";

import {
    MainContainer,
    MainTitle,
    TitleContainer,
    ColumnContainer,
    Column,
    Tabs,
} from "@beacharound/beacharound-ui";

import SubRoute from '../../components/Routes/SubRoute';

export default function Places({ match, routes, location }) {

    const tabs = [
        {
            text: "Utenti finali",
            component: Link,
            to: `${match.url}/customer`,
        },
        {
            text: "Business",
            component: Link,
            to: `${match.url}/business`,
        },
        {
            text: "Amministrazioni pubbliche",
            component: Link,
            to: `${match.url}/publicAdministration`,
        },
    ];

    const tabsArray = tabs && tabs.map((t) => t.to)

    return (
        <React.Fragment>
            <MainContainer large>
                <TitleContainer>
                    <MainTitle text="Utenti" />
                </TitleContainer>

                <ColumnContainer noMargin>
                    <Column>
                        <Tabs list={tabs} activeIndex={tabsArray.indexOf(location.pathname)} />
                    </Column>
                </ColumnContainer>

                <ColumnContainer>
                    <Column>
                        <Switch>
                            {routes?.map((page, index) => {
                                return <SubRoute key={index} {...page} />;
                            })}
                        </Switch>
                    </Column>
                </ColumnContainer>
            </MainContainer>
        </React.Fragment>
    );
}
